import { Button, Group, Menu, Stack, Text } from '@mantine/core';
import { IconCheck, IconChevronDown } from '@tabler/icons-react';
import { Cmp } from '~portal/lib';
import { ChatMode, useChatModeStore } from '~portal/stores/chat-mode-store';

const options: Array<{ mode: ChatMode; label: string; description: string }> = [
  {
    mode: 'answer',
    label: 'Answer',
    description: 'Fast, direct responses from a single reference source.',
  },
  {
    mode: 'analyse',
    label: 'Analyse',
    description: 'Detailed responses cross-referencing multiple sources.',
  },
];

export const modeLabels: Record<ChatMode, string> = {
  answer: 'Answer',
  analyse: 'Analyse',
};

export type ChatModeMenuProps = {
  disabled?: boolean;
};

/**
 * @desc Composer-embedded mode switch (Charlie rev 2). Reads and writes the
 * shared chat-mode store so the selection screen and the composer stay in step.
 */
export const ChatModeMenu: Cmp<ChatModeMenuProps> = function ({ disabled }) {
  const mode = useChatModeStore((state) => state.mode);
  const setMode = useChatModeStore((state) => state.setMode);

  return (
    <Menu position="top-end" shadow="md" width={260} withinPortal>
      <Menu.Target>
        <Button
          variant="subtle"
          color="gray"
          size="compact-sm"
          disabled={disabled}
          rightSection={<IconChevronDown size={14} />}
          aria-label={`Response mode: ${modeLabels[mode]}`}
        >
          {modeLabels[mode]}
        </Button>
      </Menu.Target>

      <Menu.Dropdown>
        {options.map((option) => (
          <Menu.Item key={option.mode} onClick={() => setMode(option.mode)}>
            <Group justify="space-between" wrap="nowrap" gap="sm">
              <Stack gap={0}>
                <Text size="sm" fw={500}>
                  {option.label}
                </Text>
                <Text size="xs" c="dimmed">
                  {option.description}
                </Text>
              </Stack>
              {option.mode === mode && <IconCheck size={16} color="var(--mantine-color-blue-7)" />}
            </Group>
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};
